import { useSortable } from '@dnd-kit/sortable';
import classNames from 'classnames';
import { Button } from 'components/atoms';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCircleFill, PiPencilSimpleLine, PiTrash, PiUser } from 'react-icons/pi';
import { ARTIST_ROLE, IArtistWithRoleForm, STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { animateLayoutChanges } from 'utils/dnd/dndUtilities';
import './ArtistRoleCard.scss';

interface IArtistRoleCardProps {
  artist: IArtistWithRoleForm;
  index: number;
  displayMode?: boolean;
  onRemove?: () => void;
  onEdit?: () => void;
  name?: string;
  sortableKey: string;
}

const ArtistRoleCard = ({
  artist,
  index,
  displayMode,
  onRemove,
  onEdit,
  name = 'artists',
  sortableKey,
}: IArtistRoleCardProps) => {
  const { t } = useTranslation();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: sortableKey,
    animateLayoutChanges,
    disabled: displayMode,
  });

  const style: CSSProperties = {
    // transform: `translate(0px, ${transform?.y}px)`,
    transform: transform
      ? `translateY(${transform.y}px) ${isDragging ? 'scale(1.02)' : ''}`
      : 'none',
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={classNames('artist-role-card', { isDragging })}
      style={style}
    >
      <div className="artist-role-card-profile">
        {artist.previewPicture ? <img src={artist.previewPicture} /> : <PiUser />}
      </div>

      <div className="artist-role-name">
        <div className="artist-role-header">{artist.nickname}</div>

        <div className="artist-role-footer">
          <div className="artist-role-footer-content">
            {t(`enum.ARTIST_ROLE.${ARTIST_ROLE[artist.role]}`)}
            <PiCircleFill />
            {t(`enum.STATUS.${STATUS[artist.artistStatus]}`)}
          </div>
        </div>
      </div>

      {!displayMode && (
        <>
          {onEdit && (
            <Button isClear onlyIcon onClick={onEdit}>
              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          <Button
            isClear
            onlyIcon
            variant={BUTTON_VARIANT.remove}
            onClick={(e) => {
              e.stopPropagation();
              onRemove && onRemove();
            }}
          >
            <Button.Icon icon={<PiTrash />} />
          </Button>
        </>
      )}
    </div>
  );
};

export default ArtistRoleCard;
